/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropInMostWatched
 */
export interface DropInMostWatched {
    /**
     * 
     * @type {string}
     * @memberof DropInMostWatched
     */
    dropId: string;
    /**
     * 
     * @type {string}
     * @memberof DropInMostWatched
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DropInMostWatched
     */
    slug: string;
    /**
     * 
     * @type {number}
     * @memberof DropInMostWatched
     */
    sessions: number;
    /**
     * 
     * @type {number}
     * @memberof DropInMostWatched
     */
    totalHours: number;
    /**
     * 
     * @type {number}
     * @memberof DropInMostWatched
     */
    uniqueViewers: number;
}

/**
 * Check if a given object implements the DropInMostWatched interface.
 */
export function instanceOfDropInMostWatched(value: object): value is DropInMostWatched {
    if (!('dropId' in value) || value['dropId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('sessions' in value) || value['sessions'] === undefined) return false;
    if (!('totalHours' in value) || value['totalHours'] === undefined) return false;
    if (!('uniqueViewers' in value) || value['uniqueViewers'] === undefined) return false;
    return true;
}

export function DropInMostWatchedFromJSON(json: any): DropInMostWatched {
    return DropInMostWatchedFromJSONTyped(json, false);
}

export function DropInMostWatchedFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropInMostWatched {
    if (json == null) {
        return json;
    }
    return {
        
        'dropId': json['dropId'],
        'name': json['name'],
        'slug': json['slug'],
        'sessions': json['sessions'],
        'totalHours': json['totalHours'],
        'uniqueViewers': json['uniqueViewers'],
    };
}

export function DropInMostWatchedToJSON(json: any): DropInMostWatched {
    return DropInMostWatchedToJSONTyped(json, false);
}

export function DropInMostWatchedToJSONTyped(value?: DropInMostWatched | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dropId': value['dropId'],
        'name': value['name'],
        'slug': value['slug'],
        'sessions': value['sessions'],
        'totalHours': value['totalHours'],
        'uniqueViewers': value['uniqueViewers'],
    };
}

